
import HTTP from './HTTP';

export default HTTP;



// WEBPACK FOOTER //
// ./src/API/HTTP/index.js